import { ReactNode, createContext, useContext } from "react";
import { useFilterRegistration } from "./filter-registration.hook";

const FilterRegistrationContext = createContext(
  {} as ReturnType<typeof useFilterRegistration>
);
export function useFilterRegistrationContext() {
  return useContext(FilterRegistrationContext);
}

interface FilterRegistrationProviderProps {
  children: ReactNode;
}
export function FilterRegistrationProvider({
  children,
}: FilterRegistrationProviderProps) {
  return (
    <FilterRegistrationContext.Provider value={useFilterRegistration()}>
      {children}
    </FilterRegistrationContext.Provider>
  );
}